import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const GET_USER_REQUEST = 'sherrinford/auth/GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'sherrinford/auth/GET_USER_SUCCESS'
export const GET_USER_ERROR = 'sherrinford/auth/GET_USER_ERROR'

const initialStates = {
  isLoading: false,
  isError: false,
  errorMessage: '',
  users: [],
}

export default createReducer(initialStates, {
  [GET_USER_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_USER_SUCCESS]: (state, res) => {
    const users = res

    return {
      ...state,
      isLoading: false,
      users,
    }
  },

  [GET_USER_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
})

export const getUsers = (cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_USER_REQUEST,
      GET_USER_SUCCESS,
      GET_USER_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/user',
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}
